
  (() => {
    const managerKey = '__zeptoWishlistOnImage';

    if (window[managerKey]) {
      window[managerKey].refresh();
      return;
    }

    const WRAP = '[data-zepto-wish]';
    const STORE_KEY = 'm-wishlist-products';
    const HEART =
      'M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z';

    let normalising = false;

    /* ---------- local fallback so the state survives a page change ------- */
    const readStore = () => {
      try {
        const raw = window.localStorage.getItem(STORE_KEY);
        return new Set(raw ? JSON.parse(raw) : []);
      } catch (e) {
        return new Set();
      }
    };

    /* ---------- helpers -------------------------------------------------- */
    const getButton = (wrap) =>
      wrap.querySelector(
        '.zepto-wish-btn, .m-wishlist-button, .m-tooltip, add-to-wishlist, wishlist-button, button, a'
      ) || wrap.firstElementChild;

    /* Writes only when the value actually differs, so repeated calls make no
       DOM mutations and the observer below can never feed itself. */
    const pinRadius = (wrap) => {
      const radius = getComputedStyle(wrap).getPropertyValue('--zepto-wish-radius').trim() || '12px';

      wrap.querySelectorAll('*').forEach((el) => {
        if (!el.style) return;
        const tag = (el.tagName || '').toLowerCase();
        if (tag === 'svg' || tag === 'path' || tag === 'span' && el.classList.contains('zepto-wish-btn__burst')) return;
        if (el.classList.contains('m-tooltip__content') || el.classList.contains('zepto-wish-btn__tip')) return;
        if (el.style.borderRadius === radius) return;
        el.style.setProperty('border-radius', radius, 'important');
      });
    };

    const readAppState = (wrap) => {
      const handle = wrap.getAttribute('data-zepto-wish-handle');
      return Boolean(handle && readStore().has(handle));
    };

    const paint = (wrap, on) => {
      const btn = getButton(wrap);
      wrap.classList.toggle('zepto-wish-on', on);
      wrap.classList.toggle('zepto-wish-visible', on);
      if (btn) {
        btn.classList.toggle('is-added', on);
        if (btn.tagName === 'BUTTON' || btn.getAttribute('role') === 'button') {
          btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
      }
    };

    /* ---------- upgrade one wrapper -------------------------------------- */
    const enhance = (wrap) => {
      const btn = getButton(wrap);
      if (!btn) return;

      normalising = true;

      btn.classList.add('zepto-wish-btn');

      /* one heart shape for every state */
      let svg = btn.querySelector('svg');
      if (!svg) {
        svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        (btn.querySelector('.m-tooltip-icon') || btn).appendChild(svg);
      }
      if (svg.getAttribute('data-zepto-heart') !== '1') {
        svg.setAttribute('data-zepto-heart', '1');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        svg.innerHTML = '<path d="' + HEART + '"></path>';
      }

      /* icon wrapper drives the pop animation */
      if (!svg.parentElement.classList.contains('zepto-wish-btn__icon')) {
        const icon = document.createElement('span');
        icon.className = 'zepto-wish-btn__icon';
        svg.parentElement.insertBefore(icon, svg);
        icon.appendChild(svg);
      }

      /* ripple element */
      if (!btn.querySelector('.zepto-wish-btn__burst')) {
        const burst = document.createElement('span');
        burst.className = 'zepto-wish-btn__burst';
        burst.setAttribute('aria-hidden', 'true');
        btn.appendChild(burst);
      }

      pinRadius(wrap);

      if (!wrap.hasAttribute('data-zepto-wish-ready')) {
        wrap.setAttribute('data-zepto-wish-ready', 'true');

        wrap.addEventListener('click', () => {
          wrap.classList.add('is-animating');
          const b = getButton(wrap);
          if (b) b.classList.add('is-animating');
          window.setTimeout(() => {
            refresh();
            pinRadius(wrap);
          }, 0);
          window.setTimeout(() => {
            wrap.classList.remove('is-animating');
            if (b) b.classList.remove('is-animating');
          }, 700);
        });
      }
      paint(wrap, readAppState(wrap));

      normalising = false;
    };

    const refresh = (root = document) => {
      root.querySelectorAll(WRAP).forEach(enhance);
    };

    /* childList only: the app replacing its own markup is what we care about.
       Watching attributes as well would react to our own class toggles. */
    let queued = false;
    const mutationObserver = new MutationObserver(() => {
      if (normalising || queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        refresh();
      });
    });

    const start = () => {
      refresh();
      mutationObserver.observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('petal:wishlist-change', () => refresh());
    document.addEventListener('shopify:section:load', () => refresh());
    document.addEventListener('shopify:section:reorder', () => refresh());

    window[managerKey] = { refresh };
  })();

(() => {
  const selector = '.m-media-wishlist-btn';
  const heart = 'M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z';
  const refresh = () => {
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem('m-wishlist-products')) || []; } catch {}
    document.querySelectorAll(selector).forEach(wrap => {
      const btn = wrap.querySelector('.m-wishlist-button[data-product-handle]');
      const svg = btn && btn.querySelector('svg');
      if (!svg) return;
      const active = handles.includes(btn.dataset.productHandle);
      if (!svg.hasAttribute('data-petal-heart')) {
        svg.setAttribute('data-petal-heart', 'true');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.innerHTML = '<path d="' + heart + '" stroke-linecap="round" stroke-linejoin="round"></path>';
      }
      const path = svg.firstElementChild;
      path.style.fill = active ? 'currentColor' : 'none';
      path.style.stroke = 'currentColor';
      path.style.strokeWidth = '2';
      svg.style.color = active ? 'var(--wl-color-active, #D93025)' : 'var(--wl-color, #111827)';
      btn.setAttribute('aria-pressed', String(active));
      wrap.classList.toggle('dn-wishlist-active', active);
    });
  };
  document.addEventListener('petal:wishlist-change', refresh);
  document.addEventListener('shopify:section:load', refresh);
  const observer = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector))))) refresh();
  });
  observer.observe(document.documentElement, {childList:true, subtree:true});
  refresh();
})();
